import {
  GET_REVIEW_REQUEST,
  GET_REVIEW_SUCCESS,
  GET_REVIEW_FAILURE,
  GET_ESIGN_SUCCESS,
  GET_ESIGN_FAILURE,
  GET_DOCUMENT_ID,
} from "./type";

const initialState = {
  loading: false,
  dataSource: null,
  eSignUrls: null,
  kyc_doc_id: null,
  kra_doc_id: null,
  user:null,
  kra_gwt:null,
  kyc_gwt:null
};

export const review = (state = initialState, action) => {
  switch (action.type) {
    case GET_REVIEW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_REVIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        dataSource: action.payload,
      };
    case GET_REVIEW_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case GET_ESIGN_SUCCESS:
      return {
        ...state,
        eSignUrls: action.payload,
        loading: false,
      };
    case GET_ESIGN_FAILURE:
      return {
        ...state,
        eSignUrls: null,
        loading: false,
      };
    case GET_DOCUMENT_ID:
      return{
        ...state,
        kyc_doc_id:action.payload.kyc_doc_id,
        kra_doc_id:action.payload.kra_doc_id,
        kra_gwt:action.payload.kra_gwt,
        kyc_gwt:action.payload.kyc_gwt,
        user:action.payload.user,
      }
    default:
      return state;
  }
};
